<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>校园视频话机</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <!-- <div class="fl">
          <img src="../../../assets/img/smart/lubo_summary_Image.png" alt="" />
        </div> -->
        <div>
          <h2>校园视频话机</h2>
          <p>智慧校园亲情视频电话机是一款融合音视频通话的公共智能终端，是家校互联与教育信息化的充分合作深度融合，为学生与家长的沟通提供一个及时有效的交流互动平台；助推教育信息化发展，建设具有前瞻性的教育辅助产品服务于教育行业。</p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix mb100">
        <li>
          <h2>学校</h2>
          <p>积极相应政策、树立良好的学校形象，为家长和学生建立沟通通道，提升学校数字化能力，学生通话管理更加便捷。</p>
        </li>
        <li>
          <h2>家长</h2>
          <p>即使孩子是住校，视频通话能拉近跟孩子的距离，后台开通服务，无需孩子自行充值，微信端使用，无需下载其它APP。</p>
        </li>
        <li>
          <h2>学生</h2>
          <p>无需额外现金充值，视频通话拉近跟家人距离，不错过家长留言，紧急情况有所通知。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SscampusfamilyPhone',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
